// Organization-level feature flags and modes
export var FeatFlagEnrollmentScheduleSelectionMode;
(function (FeatFlagEnrollmentScheduleSelectionMode) {
    FeatFlagEnrollmentScheduleSelectionMode["EXISTING_ONLY"] = "existing_only";
    FeatFlagEnrollmentScheduleSelectionMode["INLINE_ONLY"] = "inline_only";
    FeatFlagEnrollmentScheduleSelectionMode["INLINE_AND_EXISTING"] = "inline_and_existing";
})(FeatFlagEnrollmentScheduleSelectionMode || (FeatFlagEnrollmentScheduleSelectionMode = {}));
export var FeatFlagCalendarSessionTitleViewMode;
(function (FeatFlagCalendarSessionTitleViewMode) {
    FeatFlagCalendarSessionTitleViewMode["INSTRUCTOR_NAME"] = "instructor_name";
    FeatFlagCalendarSessionTitleViewMode["CUSTOMER_NAMES"] = "customer_names";
    FeatFlagCalendarSessionTitleViewMode["SCHEDULE_NAME"] = "schedule_name";
})(FeatFlagCalendarSessionTitleViewMode || (FeatFlagCalendarSessionTitleViewMode = {}));
//# sourceMappingURL=FeatureFlags.js.map